module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vc-hue', _vm.directionClass],
    attrs: {
      "role": "HuePanel"
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "vc-hue-container",
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vc-hue-pointer",
    style: ({
      top: _vm.pointerTop,
      left: _vm.pointerLeft
    }),
    attrs: {
      "role": "CurrentHuePointer"
    }
  }, [_c('div', {
    staticClass: "vc-hue-picker"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-096f160e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/Hue.vue
// module id = 1329
// module chunks = 0